import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteAnnouncement = async (id: string): Promise<void> => {
  // yes, you need to pass the id in the url before the resource name
  const response = await axiosClient.delete(`/announcements/${id}`);
  return response.data;
};

export function useDeleteAnnouncement(
  queryOptions?: UseMutationOptions<void, HttpError, { id: string }>,
) {
  return useMutation({
    mutationFn: ({ id }) => deleteAnnouncement(id),
    ...queryOptions,
  });
}
